module.exports = __webpack_public_path__ + "img/skillsD-2.6c7fb2cb.png";